import React from 'react'
import Popover from '@mui/material/Popover'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Grid from '@mui/material/Grid'
import { EBadgeType } from './calendarTypes'

interface IContent {
  label: string
  comment: string
}

interface ICellBadgeProps {
  contents: IContent[]
  type: EBadgeType
}

const chunkArray = (array: IContent[], chunkSize: number) => {
  const chunks = []
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize))
  }
  return chunks
}

const CellBadge: React.FC<ICellBadgeProps> = ({ contents, type }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const isPopoverOpen = Boolean(anchorEl)

  return (
    <div
      onMouseEnter={(event) => setAnchorEl(event.currentTarget)}
      onMouseLeave={() => setAnchorEl(null)}
      style={{
        width: '100%',
        height: '100%',
        textAlign: 'center',
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        zIndex: 10,
        userSelect: 'none',
      }}
    >
      {contents.length > 1 && (
        <div
          style={{
            width: '1.5em',
            height: '1.5em',
            backgroundColor: type === EBadgeType.Scene ? '#F5BF25' : '#43A047',
            borderRadius: '50%',
            padding: '5px',
            textAlign: 'center',
            color: type === EBadgeType.Scene ? '#000000' : '#FFFFFF',
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center',
            zIndex: 1000,
          }}
        >
          {contents.length}
        </div>
      )}
      <Popover
        sx={{ pointerEvents: 'none' }}
        disableScrollLock
        open={isPopoverOpen}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={() => setAnchorEl(null)}
        disableRestoreFocus
      >
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="flex-start"
        >
          {chunkArray(contents, 10).map((chunk, index) => (
            <Grid item key={index}>
              <List key={index}>
                {chunk.map((content, index2) => (
                  <ListItem
                    key={index2}
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      maxWidth: '200px',
                    }}
                  >
                    <div style={{ width: '100%' }}>{content.label}</div>
                    <div style={{ marginLeft: '10px' }}>
                      <i>{content.comment}</i>
                    </div>
                  </ListItem>
                ))}
              </List>
            </Grid>
          ))}
        </Grid>
      </Popover>
    </div>
  )
}

export default CellBadge
